module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAS9JREFUSInVlbFOg0Acxj/oDYw9cS5DQ6H4CCYlKYmL1YApg86uPpbvoIPP4lSuduW6NIVzkWuTCoJ3mPhNJFzuR3533x9DCCHQY8w+N/9bwMvjE95f31Du91oBRnUGz5dXAACLDuEmC0zubmHRoX6AfDEYwIlCeMsY5xe+fsBx7KkHL43hRCFMQvQDqlhnFJNkATe5aa2vE6CKSQhG8xmChxTUHesHHMcOfPhpjNF89q0+CdjlHHzFwDOGPGPymWcM248NRFE2gur0GW1GhSgKbNebAzxj4Ku1/IBdzuVakxA4UYjp/RLUHffTZCEEyqIAAEhpOhS58fVJQdUP+YeOdGvNV6pr6qcx7KC55Z0AdRqUASqjonZ1pUF12J0AfqOhFUBFQ1NaNVkl//+n/wnJk6nt/G+s8AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/send_active.png
// module id = 3q8l
// module chunks = 2